import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import initialState from './initialState';
import { ENV } from '../config';

export default function configureStore() {
  const options = {};

  if (ENV === 'development') {
    options.trace = true;
    options.traceLimit = 15;
  }

  return createStore(
    rootReducer,
    initialState,
    composeWithDevTools(options)(applyMiddleware(thunk))
  );
}
